import slick from 'slick-carousel';
$('#storeRecommendSlider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  infinite: true,
  speed: 700,
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnHover: true,
  pauseOnFocus: true
});